import { render, staticRenderFns } from "./AddInfoRevisal.vue?vue&type=template&id=473b4122&"
import script from "./AddInfoRevisal.vue?vue&type=script&lang=js&"
export * from "./AddInfoRevisal.vue?vue&type=script&lang=js&"
import style0 from "./AddInfoRevisal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports